// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37ynO","delete":"styles_delete__qqRxt","update":"styles_update__alUFY","add":"styles_add__nb0RW"};